import React from 'react'
import Marquee from "react-fast-marquee";
import { Link } from 'react-router-dom';

const ProcessThree = () => {
    return (

        <section
            className="process-area-1 bg-smoke space-bottom"
            style={{ backgroundImage: "url(assets/img/bg/shape_1.png)" }}
        >

            <div className="client-bg-area-2 space-bottom">
            </div>

            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="title-area text-center">
                            <span className="sub-title">
                                <img src="assets/img/icon/title_left.svg" alt="shape" />
                                Our Work Process
                            </span>
                            <h2 className="sec-title style2">
                                Empowering Your Business Growth
                            </h2>
                        </div>
                    </div>
                </div>
                <div className="row gy-30">
                    {/* Technical Operation */}
                    <div className="col-lg-6 col-xl-3 process-card-wrap">
                        <div className="process-card">
                            <div className="process-card_wrapp">
                                <div className="process-card-icon">
                                    <img src="assets/img/icon/process-icon-1-1.svg" alt="icon" />
                                </div>
                                <h3 className="process-card_number">01</h3>
                            </div>
                            <div className="process-card_content">
                                <span className="process-card-text">Procurement Services</span>
                                <h4 className="process-card-title">Efficient and Timely Supply</h4>
                            </div>
                        </div>
                    </div>

                    {/* Heavy Equipment Supply */}
                    <div className="col-lg-6 col-xl-3 process-card-wrap">
                        <div className="process-card">
                            <div className="process-card_wrapp">
                                <div className="process-card-icon">
                                    <img src="assets/img/icon/process-icon-1-2.svg" alt="icon" />
                                </div>
                                <h3 className="process-card_number">02</h3>
                            </div>
                            <div className="process-card_content">
                                <span className="process-card-text">Heavy Equipment Supply</span>
                                <h4 className="process-card-title">Reliable Equipment for Every Need</h4>
                            </div>
                        </div>
                    </div>

                    {/* City Works */}
                    <div className="col-lg-6 col-xl-3 process-card-wrap">
                        <div className="process-card">
                            <div className="process-card_wrapp">
                                <div className="process-card-icon">
                                    <img src="assets/img/icon/process-icon-1-3.svg" alt="icon" />
                                </div>
                                <h3 className="process-card_number">03</h3>
                            </div>
                            <div className="process-card_content">
                                <span className="process-card-text">City Works</span>
                                <h4 className="process-card-title">Transforming Urban Landscapes</h4>
                            </div>
                        </div>
                    </div>

                    {/* Personnel Supply */}
                    <div className="col-lg-6 col-xl-3 process-card-wrap">
                        <div className="process-card">
                            <div className="process-card_wrapp">
                                <div className="process-card-icon">
                                    <img src="assets/img/icon/process-icon-1-4.svg" alt="icon" />
                                </div>
                                <h3 className="process-card_number">04</h3>
                            </div>
                            <div className="process-card_content">
                                <span className="process-card-text">Personnel Supply</span>
                                <h4 className="process-card-title">Skilled Workforce for Success</h4>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default ProcessThree
